import { ChevronDown } from "@/components/Icons/utility/ChevronDown.tsx";
import { AgeSelect } from "@/components/Inputs/AgeSelect/AgeSelect.tsx";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { RootAttribute } from "@/stores/EngineStore/enums/RootAttribute.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

export const AdultAgeSelect = memo((props: { cartItem: CartAccommodationItem }) => {
  const { t } = useTranslation();
  const rootAttributes = useEngineStore((state) => state.rootAttributes);

  const renderAdultAgeSelects = useMemo(() => {
    return props.cartItem.adults?.map((adult) => (
      <div className="c-be-select-wrapper" key={adult.id}>
        <label className="c-be-select-label u-p1">{t("adultAge")}</label>
        <div className="c-be-select-wrapper__inner">
          <AgeSelect person={adult} isAdult={true} cartItemId={props.cartItem.id} />
          <ChevronDown />
        </div>
      </div>
    ));
  }, [props.cartItem, t]);

  if (!renderAdultAgeSelects.length || !rootAttributes?.[RootAttribute.ShowAdultAgePicker]) return null;

  return <div className="c-age-select">{renderAdultAgeSelects}</div>;
});

AdultAgeSelect.displayName = "AdultAgeSelect";
